export default "/images/6bde6d725a08aa804e723cbeeb04c50f.avif";